<div [ngSwitch]="pagination ? 'tableShimmer' : type">
 
  <!-- For table -->
  <ng-container *ngSwitchCase="'tableShimmer'">
    <div class="skeleton-table" [style.--cols]="cols.length">
      <div class="skelton-header-row">
        <ngx-skeleton-loader *ngFor="let _ of cols; trackBy: trackByIndex"
          [theme]="{ height: '12px', 'border-radius': '4px' }">
        </ngx-skeleton-loader>
      </div>
      <div class="skelton-body">
        <div class="skelton-row" *ngFor="let _ of rows; trackBy: trackByIndex">
          <ngx-skeleton-loader *ngFor="let _ of cols; trackBy: trackByIndex"
            [theme]="{ height: '14px', 'border-radius': '4px' }">
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </ng-container>
 
  <!--  PROFILE -->
  <ng-container *ngSwitchCase="'profileShimmer'">
    <div class="skeleton-profile-list">
      <div class="skeleton-profile" *ngFor="let _ of rows; trackBy: trackByIndex">
 
        <ngx-skeleton-loader appearance="circle" [theme]="{ width: '46px', height: '46px' }">
        </ngx-skeleton-loader>
 
        <div class="skeleton-profile__lines">
          <div class="line line--1">
            <ngx-skeleton-loader [theme]="{ width: '100%', height: '12px', 'border-radius': '4px' }">
            </ngx-skeleton-loader>
          </div>
 
          <div class="line line--2">
            <ngx-skeleton-loader
              [theme]="{ width: '100%', height: '14px', 'border-radius': '4px', 'margin-top': '8px' }">
            </ngx-skeleton-loader>
          </div>
        </div>
 
      </div>
    </div>
  </ng-container>
 
  <!-- for cards -->
  <ng-container *ngSwitchCase="'cardsShimmer'">
    <div class="skeleton-cards-grid">
      <div class="skeleton-card" *ngFor="let _ of cards; trackBy: trackByIndex">
 
        <ngx-skeleton-loader appearance="square"
          [theme]="{ width: '100%', height: '110px', 'border-radius': '12px' }"></ngx-skeleton-loader>
 
        <div class="skeleton-card__content">
 
          <ngx-skeleton-loader [theme]="{ width: '65%', height: '14px', 'border-radius': '6px' }"></ngx-skeleton-loader>
 
          <ngx-skeleton-loader *ngFor="let __ of cardLines; let idx = index; trackBy: trackByIndex" [theme]="{
          width: idx === cardLines.length - 1 ? '45%' : '100%',
          height: '12px',
          'border-radius': '6px',
          'margin-top': '8px'
        }"></ngx-skeleton-loader>
        </div>
 
      </div>
    </div>
  </ng-container>
 
  <!-- MANAGER -->
  <ng-container *ngSwitchCase="'profileCardShimmer'">
    <div class="skeleton-cards-managing">
      <div class="card-manage" *ngFor="let _ of cards; trackBy: trackByIndex">
        <div class="card-manage__row" [class.no-avatar]="!image">
 
          <!-- Avatar only when image=true -->
          <ng-container *ngIf="image">
            <ngx-skeleton-loader appearance="circle" [theme]="{ width: '56px', height: '56px' }">
            </ngx-skeleton-loader>
          </ng-container>
 
          <div class="card-manage__lines">
            <div class="line line--1">
              <ngx-skeleton-loader [theme]="{ width: '100%', height: '14px', 'border-radius': '6px' }">
              </ngx-skeleton-loader>
            </div>
 
            <div class="line line--2">
              <ngx-skeleton-loader [theme]="{ height: '12px', 'border-radius': '6px', 'margin-top': '8px' }">
              </ngx-skeleton-loader>
            </div>
 
            <div class="line line--3" *ngIf="showThirdLine">
              <ngx-skeleton-loader [theme]="{ height: '12px', 'border-radius': '6px', 'margin-top': '8px' }">
              </ngx-skeleton-loader>
            </div>
          </div>
 
        </div>
      </div>
    </div>
  </ng-container>
 
  <!-- full page shimmer -->
  <ng-container *ngSwitchCase="'formsShimmer'">
    <div class="skeleton-page">
      <div class="skelton-header-rows">
        <ngx-skeleton-loader [theme]="{ width: '100%', height: '32px', 'border-radius': '4px'}">
        </ngx-skeleton-loader>
      </div>
 
      <div class="skelton-bofddy">
        <ngx-skeleton-loader [count]="12"
          [theme]="{ width: '100%', height: '14px', 'margin-top': '12px', 'border-radius': '4px' }">
        </ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>
 
 
  <ng-container *ngSwitchDefault>
  </ng-container>
 
</div>
 